import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./ReviewFlightHeader.module.scss";

export const ReviewFlightHeader = ({ className }: PlatformComponentProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.ReviewFlightHeader;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();

  return (
    <div className={clsx(block, className)}>
      <div className={cn("text")}>
        <h2 className={cn("title")}>{t("flightReview.header.title")}</h2>
        <p className={cn("subtitle")}>{t("flightReview.header.subtitle")}</p>
      </div>
      <div className={cn("right")}></div>
    </div>
  );
};
